export default __webpack_public_path__ + "images/3935d912fa64c2303eb5d6b17d0d865b-bathing_and_toileting_how-to.svg";